import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Button, Dialog, Grid, Typography } from '@mui/material';
import { useLanguage } from 'context/AppContext';
import { ModalContent } from '../DeliveryPortalPage.styles';

interface DuplicatesFoundModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  isShown: boolean;
}

const DuplicatesFoundModal: React.FC<DuplicatesFoundModalProps> = ({ onCancel, onConfirm, isShown }) => {
  const [language] = useLanguage();

  return (
    <Dialog open={isShown} maxWidth="md">
      <ModalContent>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={11}>
            <Typography style={{ fontWeight: 'bold' }} align="center">
              {language.DeliveryPortal.DuplicatesModal.heading}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <CancelIcon color="error" fontSize="large" />
          </Grid>
        </Grid>
        <Box mb={4} />
        <Typography align="center">{language.DeliveryPortal.DuplicatesModal.subheading}</Typography>
        <Box mb={2} />
        <Typography align="center">{language.DeliveryPortal.DuplicatesModal.question}</Typography>
        <Box sx={{ mb: 4 }} />
        <Grid justifyContent="space-between" container spacing={2}>
          <Grid item>
            <Button variant="contained" startIcon={<HighlightOffIcon color="error" />} onClick={onCancel}>
              {language.DeliveryPortal.DuplicatesModal.cancelButton}
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" startIcon={<CheckCircleOutlineIcon color="success" />} onClick={onConfirm}>
              {language.DeliveryPortal.DuplicatesModal.confirmButton}
            </Button>
          </Grid>
        </Grid>
      </ModalContent>
    </Dialog>
  );
};

export default DuplicatesFoundModal;
